import { render, staticRenderFns } from "./Machine2.vue?vue&type=template&id=046c1066&scoped=true&"
import script from "./Machine2.vue?vue&type=script&lang=js&"
export * from "./Machine2.vue?vue&type=script&lang=js&"
import style0 from "./Machine2.vue?vue&type=style&index=0&id=046c1066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046c1066",
  null
  
)

export default component.exports